import Param from './param';
import Util from './module/libs/util';
import RotatAlert from './module/global/rotatAlert';

import Manager from './manager';


const manager = new Manager();
const rotatAlert = new RotatAlert();

$(window).on("load", function (e) {
    manager.init("landing");
    rotatAlert.resize();
});

/* ---------------------------------------------------

  -- event

 --------------------------------------------------- */

$("a").on("click",function () {
    $(this).addClass("is-none"); /* 非同期遷移用にダブルクリックの対策 */
})

$(window).on("scroll", function (e) {
    // let _y = window.pageYOffset || document.documentElement.scrollTop;
    // if(manager) manager.scroll.update(_y,"");
});
let _mousewheelevent = "onwheel" in document.createElement("div") ? "wheel" :  document.onmousewheel !== undefined ? "mousewheel" : "DOMMouseScroll";
$(window).on(_mousewheelevent, function(e) {

    /* スクロールの方向だけ取得 */
    let _delta = e.originalEvent.deltaY ? -(e.originalEvent.deltaY) : e.originalEvent.wheelDelta ? e.originalEvent.wheelDelta : -(e.originalEvent.detail);

    manager.wheel(e,_delta < 0 ? "next" : "prev","mouse",{y:0,x:0});


});

document.onkeydown = function(e) {
    if(e.keyCode===38){
        manager.wheel(e,"prev","keyboard",{y:0,x:0});
    }else if(e.keyCode===40){
        manager.wheel(e,"next","keyboard",{y:0,x:0});
    }
}


let touchInc = {
    x : 0,
    y : 0
}
let _touchStartTime = 0;
window.addEventListener("touchstart",function (e) {
    touchInc.x = e.changedTouches[0].pageX;
    touchInc.y = e.changedTouches[0].pageY;

    // _touchStartTime = window.performance.now();
    _touchStartTime = e.timeStamp;

    // console.log(e.timeStamp)


    /* ピンチインアウト防止 */
    if (e.touches.length > 1) {
        e.preventDefault();
        e.stopPropagation();
        return;
    }
});
let _touchMoveReset = false;
window.addEventListener("touchmove",function (e) {

    if(!manager.page.status.modalFlg){
        e.preventDefault();
        e.stopPropagation();
        return;
    }


    // touchMoveFlg = true;

});
let _touchTime = 0;
window.addEventListener("touchend",function (e) {

    let _x = e.changedTouches[0].pageX,
        _y = e.changedTouches[0].pageY;


    manager.wheel(e,touchInc.y>_y ? "next" : "prev","touch",{y:touchInc.y,x:touchInc.x});

    /* ダブルタップ防止 */
    // const now = window.performance.now();
    const now = e.timeStamp;


    // if (now - _touchTime <= 500 || _touchStartTime-now<=-100) {
    if (Math.abs(touchInc.y-_y)>0) {
        // console.log(now - _touchTime,Math.abs(touchInc.y-_y));
        e.preventDefault();
        e.stopPropagation();
        return;
    }
    // _touchTime = now;

});



window.addEventListener("mousemove",function (e) {

    let _x = e.clientX;
    let _y = e.clientY;


    if(manager.mouse) manager.mouse.update(_x,_y);

});

$(window).on("resize",function (e) {
    // executionType = "resize";
    if(manager) manager.resize();
});
$(window).on("orientationchange",function (e) {
    // executionType = "onorientationchange";
    console.log("hey")
    if(manager) manager.resize();
    rotatAlert.resize();
});